import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialSearchComponent } from 'app/components/shared/material-search/material-search.component';
import { SharedModule } from '../shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
    ],
    declarations: [MaterialSearchComponent],
    exports: [MaterialSearchComponent],
})
export class MaterialSearchModule
{
}
